module.exports = __webpack_public_path__ + "img/cable.5c568087.svg";